import { TPropsWithChildren } from '@ftd/types'
import { DOMAttributes, FormHTMLAttributes } from 'react'

type TProps = {
  onSubmit: DOMAttributes<HTMLFormElement>['onSubmit']
} & FormHTMLAttributes<HTMLFormElement>

export const Form: TPropsWithChildren<TProps> = ({ onSubmit, children, ...props }) => (
  <form onSubmit={onSubmit} style={{ width: '100%' }} noValidate {...props}>
    {children}
  </form>
)
